// extracted by mini-css-extract-plugin
module.exports = {"root":"spark_root__MDTeO","spark":"spark_spark__Khwl2"};